import React from 'react';
import { motion } from 'framer-motion';
import { X } from 'lucide-react';
const bullets = ['No reemplaza tu nivel artistico, lo potencia', 'No es instantáneo', 'Requiere constancia'];
export function HonestySection() {
  return <section className="px-6 py-32 md:py-40 bg-zinc-50 text-black pt-[100px] pb-[100px]" data-id="element-49">
      <div className="w-full max-w-3xl mx-auto" data-id="element-50">
        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-5xl md:text-7xl font-black tracking-tight mb-16 leading-[1.05]" data-id="element-51">
          Esto no es magia.
        </motion.h2>

        <div className="space-y-5 mb-16" data-id="element-52">
          {bullets.map((bullet, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="flex items-center gap-5 bg-white p-6 rounded-2xl border border-gray-100" data-id="element-53">
              <div className="w-10 h-10 rounded-full bg-gray-200 flex items-center justify-center flex-shrink-0" data-id="element-54">
                <X className="w-5 h-5 text-gray-500" data-id="element-55" />
              </div>
              <span className="text-xl md:text-2xl font-bold text-black" data-id="element-56">
                {bullet}
              </span>
            </motion.div>)}
        </div>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-2xl md:text-4xl font-bold tracking-tight leading-tight text-[#000000]" data-id="element-57"></motion.p>
      </div>
    </section>;
}